
import { item } from "../../fable_modules/fable-library-js.5.3.0/Array.js";
import { day, month } from "../../fable_modules/fable-library-js.5.3.0/DateOnly.js";
import { isNullOrWhiteSpace, substring, join, printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { textColor_textNeutral600, backgroundColor_bgPrimary700, textColor_textOnPrimary, backgroundColor_bgPrimary600, borderRadius_roundedFull, backgroundColor_bgNeutral200, md, textColor_textDanger600, space_spaceY4, space_spaceY2, textColor_textNeutral400, FocusVisible_ring, borderRadius_roundedSm, textColor_textPrimary700, hover, textColor_textPrimary600, textColor_textNeutral700, textColor_textNeutral800, textColor_textNeutral900, textColor_textNeutral500, ring_ringBlack5, ring_ring1, backgroundColor_bgSurfaceElevated, tw } from "../TailwindExtensions.js";
import { textAlign_center, fontWeight_fontBold, fontSize_text2Xl, justifyContent_justifyBetween, margin_mt4, padding_py2, padding_px6, margin_mxAuto, display_block, margin_mt2, height_h3, width_wFull, display_hidden, margin_mt6, gap_gap$002D1, display_inlineFlex, fontSize_textLg, gap_gap$002D2, cursor_cursorPointer, margin_mt1, fontWeight_fontSemibold, fontSize_textBase, fontWeight_fontMedium, fontSize_textSm, padding_p4, borderRadius_roundedMd, borderRadius_roundedLg, justifyContent_justifyCenter, alignItems_itemsCenter, display_flex, zIndex_z50, position_inset0, position_fixed$0027 } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { map, truncate, isEmpty, singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { createElement, useState, useEffect } from "react";
import React from "react";
import { createObj, disposeSafe } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { unwrap, value as value_60 } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { PageErrorKind, PageError_render_Z70A9CE70, skeletonHeading, skeletonLine } from "../Layout/Interactions.js";
import { ClientTypes_Route, ClientTypes_Msg } from "../ClientTypes.js";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { op_Division, op_Multiply, min, toInt32, fromParts, compare } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { LayoutType, pageContainer } from "../Layout/Layout.js";

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function formatDateShort(d) {
    const arg = item(month(d) - 1, monthNames);
    const arg_1 = day(d) | 0;
    return toText(printf("%s %d"))(arg)(arg_1);
}

const lightboxOverlayClass = tw(ofArray([position_fixed$0027, position_inset0, zIndex_z50, display_flex, alignItems_itemsCenter, justifyContent_justifyCenter]));

const lightboxImgClass = tw(singleton(borderRadius_roundedLg));

export function photoLightbox($props) {
    const onClose = $props.onClose;
    const photoUrl = $props.photoUrl;
    const dependencies = [photoUrl != null, onClose];
    useEffect(() => {
        const setup = (() => {
        let disp;
        if (photoUrl != null) {
            const handler = (e) => {
                const ke = e;
                if (ke.key === "Escape") {
                    onClose();
                }
            };
            document.addEventListener("keydown", handler);
            disp = {
                Dispose() {
                    document.removeEventListener("keydown", handler);
                },
            };
        }
        else {
            disp = {
                Dispose() {
                },
            };
        }
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    if (photoUrl != null) {
        const url = photoUrl;
        return HtmlHelper_createElement("div", ofArray([["className", lightboxOverlayClass], ["role", join(" ", ["dialog"])], ["aria-modal", "true"], ["aria-label", "Photo lightbox"], ["style", {
            backgroundColor: "rgba(0,0,0,0.5)",
        }], ["onClick", (_arg) => {
            onClose();
        }], ["children", [HtmlHelper_createElement("img", ofArray([["src", url], ["alt", "Enlarged photo"], ["className", lightboxImgClass], ["style", {
            maxWidth: 90 + "vw",
            maxHeight: 90 + "vh",
            objectFit: "contain",
        }], ["onClick", (e_1) => {
            e_1.stopPropagation();
        }]]))]]]));
    }
    else {
        return defaultOf();
    }
}

function truncateNote(note) {
    if (note.length <= 150) {
        return note;
    }
    else {
        return substring(note, 0, 150).trimEnd() + "...";
    }
}

const entryCardClass = tw(ofArray([backgroundColor_bgSurfaceElevated, borderRadius_roundedMd, padding_p4, ring_ring1, ring_ringBlack5]));

const dateLineClass = tw(ofArray([fontSize_textSm, textColor_textNeutral500, fontWeight_fontMedium]));

const unitsLineClass = tw(ofArray([fontSize_textBase, fontWeight_fontSemibold, textColor_textNeutral900]));

const titleLineClass = tw(ofArray([fontSize_textBase, fontWeight_fontMedium, textColor_textNeutral800]));

const noteClass = tw(ofArray([fontSize_textSm, textColor_textNeutral700, margin_mt1]));

const readMoreClass = tw(ofArray([fontSize_textSm, fontWeight_fontMedium, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer, borderRadius_roundedSm, FocusVisible_ring]));

const photoThumbClass = tw(ofArray([borderRadius_roundedMd, cursor_cursorPointer]));

export function dailyLogTimelineEntry($props) {
    const photoSize = $props.photoSize;
    const onPhotoClick = $props.onPhotoClick;
    const truncateNotes = $props.truncateNotes;
    const unitType = $props.unitType;
    const entry = $props.entry;
    const patternInput = useState(false);
    const expanded = patternInput[0];
    const needsTruncation = (truncateNotes && (entry.Note != null)) && (value_60(entry.Note).length > 150);
    return HtmlHelper_createElement("div", ofArray([["className", entryCardClass], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", dateLineClass], ["children", singleton(formatDateShort(entry.Date))]]))), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, margin_mt1]))], ["children", [HtmlHelper_createElement("span", ofArray([["className", unitsLineClass], ["children", singleton(toText(printf("%.1f %s"))(entry.UnitsCompleted)(unitType))]])), HtmlHelper_createElement("span", ofArray([["className", tw(singleton(textColor_textNeutral400))], ["children", singleton("·")]])), HtmlHelper_createElement("span", ofArray([["className", titleLineClass], ["children", singleton(entry.Title)]]))]]]))), delay(() => {
        let matchValue, note_1;
        return append((matchValue = entry.Note, (matchValue != null) ? (!isNullOrWhiteSpace(matchValue) ? ((note_1 = matchValue, singleton_1(HtmlHelper_createElement("div", ofArray([["className", noteClass], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("span", singleton(["children", singleton((needsTruncation && !expanded) ? truncateNote(note_1) : note_1)]))), delay(() => (needsTruncation ? append(singleton_1(" "), delay(() => singleton_1(HtmlHelper_createElement("button", ofArray([["className", readMoreClass], ["children", singleton(expanded ? "show less" : "read more")], ["onClick", (_arg) => {
            patternInput[1](!expanded);
        }]]))))) : empty())))))]]))))) : singleton_1(defaultOf())) : singleton_1(defaultOf())), delay(() => {
            const matchValue_1 = entry.PhotoUrl;
            if (matchValue_1 == null) {
                return singleton_1(defaultOf());
            }
            else {
                const url = matchValue_1;
                return singleton_1(HtmlHelper_createElement("button", ofArray([["type", "button"], ["aria-label", "Open log photo"], ["onClick", (_arg_1) => {
                    onPhotoClick(url);
                }], ["style", {
                    border: "none",
                    padding: 0,
                    backgroundColor: "transparent",
                }], ["children", [HtmlHelper_createElement("img", ofArray([["src", url], ["alt", "Log photo"], ["className", photoThumbClass], ["style", createObj(toList(delay(() => {
                    const size = ((photoSize === "lg") ? 120 : 64) | 0;
                    return append(singleton_1(["width", size]), delay(() => append(singleton_1(["height", size]), delay(() => singleton_1(["objectFit", "cover"])))));
                })))], ["data-testid", "log-photo-thumb"]]))]]])));
            }
        }));
    }))))))]]));
}

const sectionHeadingClass = tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral800]));

const viewAllLinkClass = tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D1, fontSize_textSm, fontWeight_fontMedium, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer, borderRadius_roundedSm, FocusVisible_ring]));

const skeletonEntryCard = HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", tw(ofArray([backgroundColor_bgSurfaceElevated, borderRadius_roundedMd, padding_p4, ring_ring1, ring_ringBlack5, space_spaceY2]))], ["children", [skeletonLine(25), skeletonLine(50), skeletonLine(75)]]]));

export function dailyLogTimelineSection($props) {
    const dispatch = $props.dispatch;
    const error = $props.error;
    const loading = $props.loading;
    const challengeId = $props.challengeId;
    const unitType = $props.unitType;
    const logs = $props.logs;
    const patternInput = useState(undefined);
    const setSelectedPhoto = patternInput[1];
    if (loading && isEmpty(logs)) {
        return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading daily updates"], ["aria-busy", "true"], ["className", tw(ofArray([space_spaceY4, margin_mt6]))], ["children", [HtmlHelper_createElement("h2", ofArray([["className", sectionHeadingClass], ["children", singleton("Recent Updates")]])), skeletonEntryCard, skeletonEntryCard]]]));
    }
    else if (error != null) {
        return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mt6))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton(value_60(error))]])), HtmlHelper_createElement("button", ofArray([["className", readMoreClass], ["children", singleton("Retry")], ["onClick", (_arg) => {
            dispatch(new ClientTypes_Msg(119, [challengeId]));
        }]]))]]]));
    }
    else if (isEmpty(logs)) {
        return defaultOf();
    }
    else {
        const displayLogs = truncate(3, logs);
        return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([space_spaceY4, margin_mt6]))], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("h2", ofArray([["className", sectionHeadingClass], ["children", singleton("Recent Updates")]]))), delay(() => append(map((entry) => createElement(dailyLogTimelineEntry, {
            entry: entry,
            unitType: unitType,
            truncateNotes: true,
            onPhotoClick: (url) => {
                setSelectedPhoto(url);
            },
            photoSize: "sm",
        }), displayLogs), delay(() => append(singleton_1(HtmlHelper_createElement("a", ofArray([["className", viewAllLinkClass], ["href", toText(printf("/challenges/%s/logs"))(challengeId)], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton("View all updates")])), createElement(icon, {
            name: new IconName(38, []),
            size: new IconSize(0, []),
            weight: new IconWeight(0, []),
        })]], ["onClick", (e) => {
            e.preventDefault();
            dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(12, [challengeId])]));
        }]]))), delay(() => singleton_1(createElement(photoLightbox, {
            photoUrl: unwrap(patternInput[0]),
            onClose: () => {
                setSelectedPhoto(undefined);
            },
        }))))))))))]]));
    }
}

const historyBackLinkClass = tw(ofArray([display_hidden, md(display_inlineFlex), alignItems_itemsCenter, gap_gap$002D2, textColor_textPrimary600, hover(textColor_textPrimary700), fontSize_textSm, fontWeight_fontMedium, cursor_cursorPointer, borderRadius_roundedSm, FocusVisible_ring]));

const progressBarContainer = tw(ofArray([width_wFull, backgroundColor_bgNeutral200, borderRadius_roundedFull, height_h3, margin_mt2]));

const progressBarFill = tw(ofArray([backgroundColor_bgPrimary600, borderRadius_roundedFull, height_h3]));

const loadMoreButtonClass = tw(ofArray([display_block, margin_mxAuto, padding_px6, padding_py2, borderRadius_roundedMd, backgroundColor_bgPrimary600, textColor_textOnPrimary, hover(backgroundColor_bgPrimary700), fontWeight_fontMedium, FocusVisible_ring]));

function historyProgressSummary(ch) {
    const pct = ((compare(ch.TargetAmount, fromParts(0, 0, 0, false, 0)) > 0) ? ~~toInt32(min(fromParts(100, 0, 0, false, 0), op_Multiply(op_Division(ch.TotalUnitsCompleted, ch.TargetAmount), fromParts(100, 0, 0, false, 0)))) : 0) | 0;
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mt4))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyBetween, fontSize_textSm, textColor_textNeutral600]))], ["children", [HtmlHelper_createElement("span", singleton(["children", singleton(toText(printf("%.1f / %.0f %s"))(ch.TotalUnitsCompleted)(ch.TargetAmount)(ch.Unit))])), HtmlHelper_createElement("span", singleton(["children", singleton(toText(printf("%d%%"))(pct))]))]]])), HtmlHelper_createElement("div", ofArray([["className", progressBarContainer], ["children", [HtmlHelper_createElement("div", ofArray([["className", progressBarFill], ["style", {
        width: pct + "%",
    }]]))]]]))]]]));
}

const historySkeleton = pageContainer(new LayoutType(1, []), singleton(HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading daily log history"], ["aria-busy", "true"], ["className", tw(singleton(space_spaceY4))], ["children", [skeletonLine(25), skeletonHeading(50), skeletonLine(75), skeletonEntryCard, skeletonEntryCard, skeletonEntryCard]]]))));

export function publicDailyLogHistoryView($props) {
    const dispatch = $props.dispatch;
    const model = $props.model;
    const patternInput = useState(undefined);
    const setSelectedPhoto = patternInput[1];
    const matchValue = model.CurrentChallenge;
    if (matchValue != null) {
        const ch = matchValue;
        return pageContainer(new LayoutType(1, []), toList(delay(() => append(singleton_1(HtmlHelper_createElement("a", ofArray([["className", historyBackLinkClass], ["href", toText(printf("/challenges/%s"))(ch.Id)], ["children", [createElement(icon, {
            name: new IconName(37, []),
            size: new IconSize(0, []),
            weight: new IconWeight(0, []),
        }), HtmlHelper_createElement("span", singleton(["children", singleton("Back to challenge")]))]], ["onClick", (e) => {
            e.preventDefault();
            dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(2, [ch.Id])]));
        }]]))), delay(() => append(singleton_1(HtmlHelper_createElement("h1", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, textColor_textNeutral900, margin_mt4]))], ["children", singleton("Daily Log History")]]))), delay(() => append(singleton_1(historyProgressSummary(ch)), delay(() => append((model.LoadingPublicDailyLogs && isEmpty(model.PublicDailyLogs)) ? singleton_1(HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading daily updates"], ["aria-busy", "true"], ["className", tw(ofArray([space_spaceY4, margin_mt6]))], ["children", [skeletonEntryCard, skeletonEntryCard, skeletonEntryCard]]]))) : (((model.PublicDailyLogsError != null) && isEmpty(model.PublicDailyLogs)) ? singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(singleton(margin_mt6))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton(value_60(model.PublicDailyLogsError))]])), HtmlHelper_createElement("button", ofArray([["className", readMoreClass], ["children", singleton("Retry")], ["onClick", (_arg) => {
            dispatch(new ClientTypes_Msg(119, [ch.Id]));
        }]]))]]]))) : ((isEmpty(model.PublicDailyLogs) && !model.LoadingPublicDailyLogs) ? singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral500, margin_mt6, textAlign_center]))], ["children", singleton("No updates yet.")]]))) : singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([space_spaceY4, margin_mt6]))], ["children", toList(delay(() => append(map((entry) => createElement(dailyLogTimelineEntry, {
            entry: entry,
            unitType: ch.Unit,
            truncateNotes: false,
            onPhotoClick: (url) => {
                setSelectedPhoto(url);
            },
            photoSize: "lg",
        }), model.PublicDailyLogs), delay(() => append(model.PublicDailyLogsHasMore ? singleton_1(HtmlHelper_createElement("button", ofArray([["className", loadMoreButtonClass], ["disabled", model.LoadingPublicDailyLogs], ["children", singleton(model.LoadingPublicDailyLogs ? "Loading..." : "Load more")], ["onClick", (_arg_1) => {
            dispatch(new ClientTypes_Msg(117, []));
        }]]))) : empty(), delay(() => {
            let msg;
            const matchValue_1 = model.PublicDailyLogsError;
            let matchResult, msg_1;
            if (matchValue_1 != null) {
                if ((msg = matchValue_1, !isEmpty(model.PublicDailyLogs))) {
                    matchResult = 0;
                    msg_1 = matchValue_1;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600, textAlign_center]))], ["children", singleton(msg_1)]])));
                default:
                    return singleton_1(defaultOf());
            }
        }))))))]]))))), delay(() => singleton_1(createElement(photoLightbox, {
            photoUrl: unwrap(patternInput[0]),
            onClose: () => {
                setSelectedPhoto(undefined);
            },
        })))))))))))));
    }
    else if (model.LoadingChallenge) {
        return historySkeleton;
    }
    else {
        return PageError_render_Z70A9CE70(new PageErrorKind(0, ["The challenge you\'re looking for doesn\'t exist or has been moved."]), undefined, new IconName(55, []), "Browse Challenges", "/challenges");
    }
}

//# sourceMappingURL=DailyLogTimeline.js.map
